import type { AuthApiPayload, OAuthParamsV2 } from '../types';
import type { AuthContext } from '../components/LowLevelAuthFlowView/LowLevelAuthFlowMachineDefinition';
import { buildApiPayload } from './buildApiPayload';

/**
 * Creates a `buildAuthPayload` function (for `LowLevelAuthFlowConfig`) bound
 * to a given `appId`, adapting the FSM's `AuthContext` into the wire-format
 * `AuthApiPayload`. Shared between the account and auth domains' auth-config
 * fetchers.
 */
export function createBuildAuthPayload(appId?: number) {
  return function buildAuthPayloadFn(
    params: AuthContext
  ): Promise<AuthApiPayload<OAuthParamsV2>> {
    const base = buildApiPayload(
      params.sessionId,
      params.steps,
      params.urlParams,
      params.oAuthParams,
      params.oAuthState,
      params.oAuthScopeSet,
      params.mcpParams,
      appId
    );
    return Promise.resolve(
      params.customParams
        ? { ...base, customParams: params.customParams }
        : base
    );
  };
}
